import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputUserSyncOptionAddModifyRelation } from './InputUserSyncOptionAddModifyRelation.entity';

export class InputUserSyncOptionsRelation<T extends EMode = EMode.entity> {
  /** Alias: addModify */
  addModify?: InputUserSyncOptionAddModifyRelation<T>[];
  /** Alias: remove */
  remove?: string[];

  __typename?: string;
}

const fields: FieldDefinitions<InputUserSyncOptionsRelation> = {
  addModify: {
    alias: 'addModify',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputUserSyncOptionsRelationEntityDefinition: EntitiyDefinition<InputUserSyncOptionsRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputUserSyncOptionsRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
